import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { ConditionalConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';

export class ConditionalNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: ConditionalConfig) {
    super(id, NodeType.Conditional, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['targetNodeId'] == null || this.config['statuses'] == null;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0 || 1) this.childrenNodes.push(node);
    else console.warn('TENEMOS CHILD');
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else console.warn('TENEMOS PARENT');
  }

  initNodeConfig() {
    (this.config as ConditionalConfig).targetNodeId = null;
    (this.config as ConditionalConfig).statuses = null;
    (this.config as ConditionalConfig).cases = { false: null, true: null };
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];
    let errorStatus = false;

    if (this.config['targetNodeId'] == null) {
      errors.push({
        nodeId: this.id,
        errorMessage: ValidationError.NO_TARGET_NODE,
        params: { nodoType: 'Condicional de Notificación' },
      });
    }

    if (this.config['statuses'] == null || errorStatus) {
      errors.push({
        nodeId: this.id,
        errorMessage: ValidationError.NO_STATUS,
        params: { nodoType: 'Condicional de Notificación' },
      });
    }

    if (this.config['cases']?.false == null || this.config['cases']?.true == null) {
      errors.push({
        nodeId: this.id,
        errorMessage: ValidationError.NO_CASE_CONDITIONAL,
        params: { nodoType: 'Condicional de Notificación' },
      });
    }

    return errors;
  }
  override validateConnectivity(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];
    if (this.parentNodes.length === 0) {
      errors.push({
        nodeId: this.id,
        errorMessage: getValidationErrorMessage(ValidationError.NODE_MISSING_PARENT),
      });
    }
    if (this.childrenNodes.length < 2) {
      errors.push({
        nodeId: this.id,
        errorMessage: getValidationErrorMessage(ValidationError.CONDITIONAL_MISSING_BRANCH),
      });
    }
    return errors;
  }

  cloneWithConfig(newConfig: Partial<ConditionalConfig>): ConditionalNode {
    const cfg = {
      ...((this.config as ConditionalConfig) || {}),
      ...newConfig,
    } as ConditionalConfig;
    const clone = new ConditionalNode(this.id, { x: this.position.x, y: this.position.y }, cfg);
    clone.childrenNodes = this.childrenNodes.slice();
    clone.parentNodes = this.parentNodes.slice();
    return clone;
  }
}
